import React from "react";

export default function AGB() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 sm:py-20" data-testid="agb-page">
      <div className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">— Rechtliches</div>
      <h1 className="font-display text-4xl sm:text-5xl text-ink leading-tight">
        Allgemeine Geschäftsbedingungen
      </h1>
      <p className="mt-4 text-sm text-ink-muted">Stand: Februar 2026</p>

      <div className="mt-8 p-5 bg-sand-soft border border-border rounded-md text-[15px] leading-relaxed">
        Wir freuen uns, dass du dich für eine Behandlung bei <strong>Ayurveda Aargau</strong> interessierst.
        Mit der Buchung eines Termins, dem Kauf eines Gutscheins oder der Inanspruchnahme einer Beratung
        kommt zwischen dir und Regula Müller – Ayurveda Aargau (nachfolgend «Praxis») ein Vertrag zustande.
        Die nachfolgenden Allgemeinen Geschäftsbedingungen (AGB) bilden zusammen mit der jeweiligen
        Leistungsbeschreibung einen integrierenden Bestandteil dieses Vertrages.
      </div>

      <div className="mt-12 space-y-10 text-ink leading-relaxed text-[15px]">
        <Section number="1" title="Vertragsabschluss">
          <Sub number="1.1" title="Buchungsanfrage">
            Durch deine Online-Buchung über das Buchungsformular, eine schriftliche, telefonische
            oder persönliche Anfrage gibst du eine <strong>unverbindliche Buchungsanfrage</strong> ab.
            Der Behandlungsvertrag kommt erst zustande, sobald die Praxis dir den Termin innerhalb
            von maximal 48 Stunden telefonisch definitiv bestätigt. Bis zur telefonischen Bestätigung
            behält sich die Praxis vor, Buchungsanfragen ohne Angabe von Gründen abzulehnen.
          </Sub>
          <Sub number="1.2" title="Vertragspartei">
            Vertragspartei der Kundin ist <strong>Regula Müller – Ayurveda Aargau</strong>,
            mit Sitz an Obere Feldeggstr. 13, 5614 Sarmenstorf (Praxis Sarmenstorf) sowie
            Aarestrasse 20, 5102 Rupperswil (Praxis Rupperswil).
          </Sub>
          <Sub number="1.3" title="Buchung für Dritte">
            Buchst du als Käuferin einen Gutschein oder einen Termin für eine andere Person, so
            stehst du dieser Person gegenüber für die Erfüllung der Vertragspflichten
            (insbesondere Bezahlung und Erscheinungspflicht) wie für deine eigenen Verpflichtungen ein.
          </Sub>
          <Sub number="1.4" title="Anwendungsbereich">
            Diese AGB gelten für alle Behandlungen, Beratungen und Gutscheinkäufe, die über die Praxis
            oder die Webseite <strong>ayurveda-aargau.ch</strong> angeboten werden. Die Behandlungen
            werden ausschliesslich <strong>für Frauen</strong> angeboten.
          </Sub>
        </Section>

        <Section number="2" title="Leistungen">
          <Sub number="2.1" title="Angebotene Leistungen">
            Die Praxis bietet ayurvedische Massagen (z.B. Abhyanga, Kalari, Rückenmassage,
            Kopfmassage, Fussmassage, Garshana), Klangschalenmassagen sowie Ernährungsberatung
            nach den Prinzipien des Ayurveda an. Inhalt, Dauer und Preis der jeweiligen Behandlung
            findest du in der Leistungsbeschreibung auf der Webseite.
          </Sub>
          <Sub number="2.2" title="Charakter der Leistungen">
            Sämtliche angebotenen Behandlungen dienen ausschliesslich der <strong>Entspannung,
            dem allgemeinen Wohlbefinden und der Prävention</strong>. Sie sind <strong>keine medizinischen
            Therapien</strong>, ersetzen weder eine ärztliche Diagnose noch eine medizinische
            Behandlung und stellen kein Heilversprechen dar.
          </Sub>
          <Sub number="2.3" title="Krankenkassen-Anerkennung">
            <div className="p-4 bg-terracotta/5 border-l-4 border-terracotta rounded">
              <p className="font-medium text-ink">
                Die Praxis und die angebotenen Leistungen sind <strong>nicht von den Schweizer
                Krankenkassen anerkannt</strong>.
              </p>
              <p className="mt-2 text-ink/85">
                Eine Kostenrückerstattung – weder über die obligatorische Grundversicherung
                noch über eine private Zusatzversicherung – ist <strong>nicht möglich</strong>.
                Die Behandlungen sind ausschliesslich von der Kundin selbst zu tragen.
                Die Praxis stellt keine krankenkassentauglichen Rechnungen aus.
              </p>
            </div>
          </Sub>
        </Section>

        <Section number="3" title="Preise und Zahlung">
          <Sub number="3.1" title="Preise">
            Es gelten die zum Zeitpunkt der Buchung auf der Webseite angegebenen Preise in
            Schweizer Franken (CHF). Sofern auf den Rechnungen nicht ausdrücklich anders ausgewiesen,
            sind die Preise inklusive der gesetzlichen Mehrwertsteuer (sofern anwendbar).
          </Sub>
          <Sub number="3.2" title="Preisänderungen">
            Die Praxis behält sich vor, die Preise jederzeit anzupassen. Massgebend ist der zum
            Zeitpunkt deiner Buchung publizierte Preis. Bereits bestätigte Termine sind von
            Preisänderungen nicht betroffen.
          </Sub>
          <Sub number="3.3" title="Zahlungsarten">
            Zahlbar sind die Behandlungen direkt nach der Behandlung in der Praxis durch:
            <ul className="mt-2 space-y-1 list-disc pl-5">
              <li>Bar (Schweizer Franken)</li>
              <li>Twint vor Ort</li>
              <li>Einlösung eines gültigen Gutscheins</li>
            </ul>
            <p className="mt-2">Für den Online-Kauf von Gutscheinen mit Versand per Post wird die Zahlung mittels
            Kreditkarte über den Zahlungsdienstleister <strong>Stripe Payments Europe Ltd.</strong>
            (Dublin, Irland) abgewickelt.</p>
          </Sub>
          <Sub number="3.4" title="Zahlungsverzug">
            Bleibt eine Rechnung trotz Mahnung unbezahlt, behält sich die Praxis vor, sämtliche
            Mahngebühren, Verzugszinsen sowie Inkassokosten in Rechnung zu stellen.
          </Sub>
        </Section>

        <Section number="4" title="Termine, Verschiebung und Stornierung">
          <Sub number="4.1" title="Stornierung durch die Kundin">
            Termine können <strong>kostenlos bis spätestens 24 Stunden vor Behandlungsbeginn</strong>{" "}
            verschoben oder storniert werden. Massgebend ist der Eingang der Mitteilung per
            E-Mail oder Telefon.
            <div className="mt-3 p-3 bg-sand-soft border border-border rounded text-sm">
              Bei Stornierung weniger als 24 Stunden vor dem Termin oder bei Nichterscheinen
              behält sich die Praxis vor, <strong>den vollen Behandlungsbetrag</strong> in Rechnung zu stellen.
            </div>
          </Sub>
          <Sub number="4.2" title="Verspätung">
            Bei Verspätung der Kundin wird die Behandlungszeit um die entsprechende Zeit
            verkürzt, ohne dass sich der Preis reduziert. Dies dient dem fairen Zeitmanagement
            gegenüber nachfolgenden Kundinnen.
          </Sub>
          <Sub number="4.3" title="Stornierung durch die Praxis">
            Die Praxis kann Termine bei Krankheit, Unfall, höherer Gewalt oder unvorhersehbaren
            Ereignissen ohne weitere Folgen verschieben. Du wirst unverzüglich kontaktiert,
            um einen Ersatztermin zu vereinbaren. Eine darüber hinausgehende Entschädigung
            ist ausgeschlossen.
          </Sub>
          <Sub number="4.4" title="Vorzeitiger Abbruch">
            Wenn du eine Behandlung aus einem in deiner Person liegenden Grund vorzeitig
            abbrechen musst, besteht kein Anspruch auf eine teilweise Rückerstattung
            des Behandlungspreises.
          </Sub>
        </Section>

        <Section number="5" title="Gesundheitliche Eignung und Kontraindikationen">
          <Sub number="5.1" title="Informationspflicht der Kundin">
            Du bist verpflichtet, die Praxis vor der Behandlung über alle gesundheitlich
            relevanten Umstände wahrheitsgemäss zu informieren, insbesondere über:
            <ul className="mt-2 space-y-1 list-disc pl-5">
              <li>Schwangerschaft</li>
              <li>Allergien (insbesondere gegen ätherische Öle und Kräuter)</li>
              <li>Akute oder chronische Erkrankungen</li>
              <li>Medikamenteneinnahme</li>
              <li>Frische Operationen, Wunden oder Hautveränderungen</li>
            </ul>
          </Sub>
          <Sub number="5.2" title="Kontraindikationen">
            Bei folgenden Zuständen sollte vor der Behandlung Rücksprache mit einer Ärztin
            oder einem Arzt gehalten werden:
            <ul className="mt-2 space-y-1 list-disc pl-5">
              <li>Fieber, akute Infekte oder ansteckende Krankheiten</li>
              <li>Frische Verletzungen, offene Wunden, Hautentzündungen</li>
              <li>Schwere Herz-Kreislauf-Erkrankungen, Thrombose</li>
              <li>Krebserkrankungen während laufender Therapie</li>
              <li>Erste drei Monate der Schwangerschaft</li>
            </ul>
          </Sub>
          <Sub number="5.3" title="Verweigerung durch die Praxis">
            Die Praxis behält sich vor, eine Behandlung zu verweigern oder abzubrechen, wenn
            gesundheitliche Risiken erkennbar sind oder du gegen deine Informationspflicht
            gemäss Ziffer 5.1 verstossen hast. In diesem Fall wird der volle Behandlungspreis
            geschuldet.
          </Sub>
        </Section>

        <Section number="6" title="Verhalten in der Praxis">
          <Sub number="6.1" title="Hygiene">
            Du verpflichtest dich, sauber und in körperlich gepflegtem Zustand zur Behandlung
            zu erscheinen. Die Praxis stellt frische Tücher und Decken zur Verfügung.
          </Sub>
          <Sub number="6.2" title="Bekleidung">
            Bei ölhaltigen Behandlungen (z.B. Abhyanga) empfehlen wir gut waschbare Kleidung
            sowie eine Kopfbedeckung mitzubringen. Spezifische Hinweise findest du in der
            jeweiligen Leistungsbeschreibung.
          </Sub>
          <Sub number="6.3" title="Ausschluss">
            Die Praxis kann Kundinnen von der Behandlung ausschliessen, wenn diese sich
            unangemessen verhalten, andere Anwesende stören oder gegen die Hausordnung
            verstossen. Bezahlte Beträge werden in solchen Fällen nicht zurückerstattet.
          </Sub>
        </Section>

        <Section number="7" title="Gutscheine">
          <Sub number="7.1" title="Gültigkeit">
            Gutscheine sind ab Ausstellungsdatum <strong>24 Monate</strong> gültig. Nach Ablauf
            verfällt der nicht eingelöste Betrag ohne Anspruch auf Rückerstattung.
          </Sub>
          <Sub number="7.2" title="Übertragbarkeit und Auszahlung">
            Gutscheine sind übertragbar, jedoch <strong>nicht in bar auszahlbar</strong>.
            Restbeträge bleiben bis zum Ablaufdatum für weitere Behandlungen einlösbar.
          </Sub>
          <Sub number="7.3" title="Verlust">
            Bei Verlust oder Diebstahl eines Gutscheins kann kein Ersatz geleistet werden.
            Gutschein-Codes sind sicher aufzubewahren.
          </Sub>
          <Sub number="7.4" title="Versand">
            Bei Bestellungen mit Versand übernimmt die Praxis keine Haftung für Verzögerungen
            oder Verlust durch den Postdienst. Nach erfolgreicher Online-Zahlung wird der
            Gutschein zusätzlich digital per E-Mail (PDF) zugestellt.
          </Sub>
          <Sub number="7.5" title="Rückgaberecht">
            Da Gutscheine sofort verfügbar sind, besteht <strong>kein Widerrufs- oder
            Rückgaberecht</strong> nach Vertragsabschluss.
          </Sub>
        </Section>

        <Section number="8" title="Haftung">
          <Sub number="8.1" title="Allgemeine Haftung">
            Die Praxis haftet ausschliesslich für Schäden, die durch grobe Fahrlässigkeit oder
            Vorsatz der Praxis verursacht wurden. Eine Haftung für leichte Fahrlässigkeit
            ist ausgeschlossen, soweit gesetzlich zulässig.
          </Sub>
          <Sub number="8.2" title="Haftungsausschluss">
            Die Praxis haftet insbesondere nicht für Schäden, die auf folgendes zurückzuführen sind:
            <ul className="mt-2 space-y-1 list-disc pl-5">
              <li>Verschwiegene oder nicht angekündigte Vorerkrankungen, Allergien oder Schwangerschaft</li>
              <li>Verstoss gegen die Informationspflicht gemäss Ziffer 5.1</li>
              <li>Höhere Gewalt oder unvorhersehbare Ereignisse</li>
              <li>Verhalten der Kundin entgegen den Anweisungen der Praxis</li>
            </ul>
          </Sub>
          <Sub number="8.3" title="Haftungsbegrenzung">
            Die Haftung der Praxis für Sach- und Vermögensschäden ist auf den Wert der
            jeweiligen Behandlung beschränkt. Diese Begrenzung gilt nicht bei Vorsatz oder
            grober Fahrlässigkeit sowie bei Personenschäden.
          </Sub>
          <Sub number="8.4" title="Wertgegenstände">
            Für mitgebrachte Wertgegenstände (Bargeld, Schmuck, Mobiltelefone, Karten etc.)
            wird in den Räumlichkeiten der Praxis keine Haftung übernommen. Bewahre Wertsachen
            stets sicher bei dir auf.
          </Sub>
          <Sub number="8.5" title="Aussergerichtliche Schadensregulierung">
            Schadensansprüche sind innerhalb von 30 Tagen nach Kenntnisnahme schriftlich
            (per E-Mail oder Brief) bei der Praxis geltend zu machen. Werden diese Fristen
            nicht eingehalten, erlöschen sämtliche Ansprüche.
          </Sub>
        </Section>

        <Section number="9" title="Beanstandungen">
          <Sub number="9.1" title="Sofortige Meldung">
            Sollten während oder unmittelbar nach einer Behandlung Beanstandungen entstehen,
            müssen diese der Praxis <strong>unverzüglich</strong> bekannt gegeben werden, damit
            eine sofortige Abhilfe oder Nachbesserung erfolgen kann.
          </Sub>
          <Sub number="9.2" title="Schriftliche Geltendmachung">
            Konnte vor Ort keine Lösung gefunden werden, muss die Beanstandung innerhalb von
            <strong> 14 Tagen</strong> nach der Behandlung schriftlich per E-Mail an{" "}
            <a href="mailto:contact@ayurveda-aargau.ch" className="text-terracotta hover:underline">
              contact@ayurveda-aargau.ch
            </a>{" "}
            eingereicht werden. Verspätet eingereichte Beanstandungen können nicht
            mehr berücksichtigt werden.
          </Sub>
        </Section>

        <Section number="10" title="Datenschutz">
          <Sub number="10.1" title="Erhebung von Daten">
            Für die korrekte Vertragsabwicklung benötigt die Praxis verschiedene personenbezogene
            Daten der Kundinnen (Name, Adresse, Geburtsdatum, E-Mail, Telefonnummer, gesundheitliche
            Angaben usw.). Die Erhebung und Verarbeitung dieser Daten erfolgt ausschliesslich
            zur Erfüllung des Vertrages.
          </Sub>
          <Sub number="10.2" title="Datenschutzerklärung">
            Sämtliche Einzelheiten zur Erhebung, Verarbeitung und Speicherung deiner Daten,
            sowie zu deinen Rechten gemäss DSG/DSGVO, sind in der separaten{" "}
            <a href="/datenschutz" className="text-terracotta hover:underline">Datenschutzerklärung</a>{" "}
            geregelt. Diese bildet einen integralen Bestandteil dieser AGB.
          </Sub>
          <Sub number="10.3" title="Vertraulichkeit">
            Die Praxis behandelt sämtliche im Rahmen einer Behandlung erlangten Informationen
            <strong> streng vertraulich</strong> und gibt diese nicht an Dritte weiter, ausser
            es besteht eine gesetzliche Verpflichtung dazu oder eine ausdrückliche Einwilligung
            der Kundin.
          </Sub>
        </Section>

        <Section number="11" title="Änderungen der AGB">
          Die Praxis behält sich vor, diese AGB jederzeit zu ändern. Massgebend für deinen
          Vertrag sind stets die zum Zeitpunkt deiner Buchung publizierten AGB. Eine rückwirkende
          Anwendung geänderter AGB findet nicht statt.
        </Section>

        <Section number="12" title="Salvatorische Klausel">
          Sollte eine Bestimmung dieser AGB ganz oder teilweise unwirksam sein oder werden,
          bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt. Anstelle der
          unwirksamen Bestimmung gilt diejenige wirksame Regelung, die dem wirtschaftlichen
          Zweck der ursprünglichen Bestimmung am nächsten kommt.
        </Section>

        <Section number="13" title="Anwendbares Recht und Gerichtsstand">
          <Sub number="13.1" title="Anwendbares Recht">
            Es gilt ausschliesslich Schweizer Recht unter Ausschluss des UN-Kaufrechts und
            kollisionsrechtlicher Vorschriften.
          </Sub>
          <Sub number="13.2" title="Gerichtsstand">
            Ausschliesslicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang
            mit diesen AGB und dem Vertragsverhältnis ist <strong>Aarau, Schweiz</strong>.
          </Sub>
        </Section>

        <div className="mt-12 pt-8 border-t border-border text-sm text-ink-muted">
          <p className="font-display text-base text-ink mb-2">Regula Müller – Ayurveda Aargau</p>
          <p>
            Obere Feldeggstr. 13, 5614 Sarmenstorf<br />
            Aarestrasse 20, 5102 Rupperswil<br />
            <a href="mailto:contact@ayurveda-aargau.ch" className="text-terracotta hover:underline">
              contact@ayurveda-aargau.ch
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

const Section = ({ number, title, children }) => (
  <section>
    <h2 className="font-display text-2xl sm:text-3xl mb-4 pb-2 border-b border-border">
      <span className="text-terracotta mr-2">{number}.</span> {title}
    </h2>
    <div className="space-y-5">{children}</div>
  </section>
);

const Sub = ({ number, title, children }) => (
  <div>
    <h3 className="font-medium text-ink mb-2">
      <span className="text-terracotta mr-2">{number}</span> {title}
    </h3>
    <div className="text-ink/85">{children}</div>
  </div>
);
